import { useQuery } from '@tanstack/react-query';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import CardSkeltonPlay from '../../Shared/CardSkelton/CardSkelton';
// import Addsterra from '../Addsterra/Addsterra';
import ButtonSection from '../../components/ButtonSection';
import CpaModal from '../../components/ModalBox/CpaModal';
import MovieDetails from '../../components/MovieDetails';
import Populers from '../Home/HeroSlider/Populers';
import SugestedShow from '../Home/Suggested/SugestedShow';
import './Movie.css';
import JwPlayer from './videoPlayer/JwPlayer';

const Movie = () => {
    const [showModal, setShowModal] = useState(false);
    console.log(showModal);
    // const { similar } = useContext(AuthContext);
    // const suggested = similar?.results;

    // popunder and social bar code
    // useEffect(() => {
    //     const script1 = document.createElement('script');
    //     script1.type = 'text/javascript';
    //     script1.src = '//credulityicicle.com/d3/58/94/d35894be4dc4875d816fab194f3bd509.js';

    //     const script2 = document.createElement('script');
    //     script2.type = 'text/javascript';
    //     script2.src = '//pl19975509.highrevenuegate.com/12/25/b6/1225b663f0365d3c1bb1b1e4596ba98e.js';

    //     document.head.appendChild(script1);
    //     document.head.appendChild(script2);

    //     return () => {
    //         document.head.removeChild(script1);
    //         // document.head.removeChild(script2);
    //     };
    // }, []);

    const API_KEY = '60328c60edaea9ec7115178b6e8c7a3a';
    const { id } = useParams();
    const { data: currentMovieDetail = [], isLoading } = useQuery({
        queryKey: ['currentMovieDetail', id],
        queryFn: async () => {
            const res = await fetch(`https://api.themoviedb.org/3/movie/${id}?api_key=${API_KEY}&language=en-US`);
            const data = await res.json();
            return data;
        }
    })


    const imgUrl = 'https://image.tmdb.org/t/p/w500';

    const posterImage = imgUrl + currentMovieDetail?.poster_path;
    // const bannerImage = imgUrl + currentMovieDetail?.backdrop_path;

    if (isLoading) {
        return (
            <div className='bg-[#090833] flex items-end justify-center mt-[5rem] pt-[8px] pb-[270px]'>
                <CardSkeltonPlay></CardSkeltonPlay>
            </div>
        )
    }

    return (
        <div className='lg:px-24 md:px-4 px-2 py-20 pt-[3rem] mt-12 bg-[#090833] text-white movie' style={{
            backgroundImage: `linear-gradient(to bottom, rgba(0,0,0,0.5) 0%, rgba(0,0,0,0.5) 100%), url(${posterImage})`,
            backgroundRepeat: "no-repeat",
            // backgroundSize: '100% 100%',
            backgroundSize: 'cover',
            backgroundPosition: '50% 50%',
            // height: "100vh",
            objectFit: "cover",
            objectPosition: "top left"
        }}>

            <div className="w-full shadow" style={{
                backgroundImage: `linear-gradient(to bottom, rgba(0,0,0,0.5) 0%, rgba(0,0,0,0.5) 100%), url(${posterImage})`,
                backgroundRepeat: "no-repeat",
                // backgroundSize: '100% 100%',
                backgroundSize: 'cover',
                backgroundPosition: '50% 100%',

            }}>
                {/* <CustomVideo currentMovieDetail={currentMovieDetail} key={currentMovieDetail?.posterImage} videoId="gLuhrhEfQBc"></CustomVideo> */}

            </div>


            <JwPlayer currentMovieDetail={currentMovieDetail} key={currentMovieDetail?.posterImage} videoId="1i0rsjnSAjD3NVCEi5cv2Kmo_gZSdH6AC" setShowModal={setShowModal}></JwPlayer>


            <ButtonSection setShowModal={setShowModal}></ButtonSection>
            {showModal && <CpaModal showModal={showModal} setShowModal={setShowModal} ></CpaModal>}



            {
                currentMovieDetail
                    ?
                    (<MovieDetails currentMovieDetail={currentMovieDetail} posterImage={posterImage} setShowModal={setShowModal}></MovieDetails>)
                    :
                    (<p>No data found</p>)
            }

            <SugestedShow props={"Sugested Movies"}></SugestedShow>
            <Populers props={"Recommendations"}></Populers>


        </div>
    );
};

export default Movie;